export interface SubApp {
  name: string;
  title: string;
  description: string;
  icon: string;
  entry?: string;
  container?: string;
  isExternal?: boolean;
}

export const FRONTEND_MENUS: Record<string, SubApp> = {
  userManage: {
    name: 'userManage',
    title: '统一用户中心',
    description: '用户权限管理与身份认证',
    icon: 'users'
  },
  homeCare: {
    name: 'homeCare',
    title: '居家养老',
    description: '智能化居家养老服务',
    icon: 'home'
  },
  officerCare: {
    name: 'officerCare',
    title: '干休所智慧养老平台',
    description: '精准服务 精细管理老干部',
    icon: 'institution'
  },
  educationCare: {
    name: 'educationCare',
    title: '社区居家智慧养老平台',
    description: '教学服务 精细管理',
    icon: 'community'
  },
  gtzhyl: {
    name: 'gtzhyl',
    title: '居家及社区智慧养老平台',
    description: '精准服务 精细管理长者',
    icon: 'home'
  },
  devicesManage: {
    name: 'devicesManage',
    title: '设备接入管理',
    description: '智能设备统一接入与管理',
    icon: 'devices'
  },
  zuoweiCockpit1: {
    title: '作为科技数字驾驶舱',
    name: 'zuoweiCockpit1',
    description: '数据洞察，精准服务',
    icon: 'statistics',
    entry: 'https://aiot-qa.zuowei.com:8000/#/home',
    isExternal: true // 标识为外部链接
  },
  zuoweiCockpit2: {
    title: '五大场景解决方案驾驶舱',
    name: 'zuoweiCockpit2',
    description: '全场景软硬件一体化协同解决方案',
    icon: 'statistics',
    entry: 'https://aiot-qa.zuowei.com:8010/#/homeCare',
    isExternal: true // 标识为外部链接
  },
  zuoweiCockpit3: {
    title: '德庆福利院安全监测平台',
    name: 'zuoweiCockpit3',
    description: '',
    icon: 'statistics',
    entry: 'https://qinglanst.com/',
    isExternal: true // 标识为外部链接
  }
};

export const FRONTEND_MENU_TITLES = Object.values(FRONTEND_MENUS).map(app => app.title);
